import { GriffelStyle, makeStyles, tokens } from '@fluentui/react-components';

const flexCenter: GriffelStyle = {
  display: 'flex',
  alignItems: 'center',
};

const flexColumn: GriffelStyle = {
  ...flexCenter,
  flexDirection: 'column',
};

const statusHighlight: GriffelStyle = {
  fontWeight: tokens.fontWeightSemibold,
};

export const usePlanHabitDetailsStyles = makeStyles({
  progressSection: {
    ...flexColumn,
    gap: tokens.spacingVerticalXXL,
  },
  progressRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: tokens.spacingHorizontalXXXL,
  },
  progressColumn: {
    ...flexColumn,
    gap: tokens.spacingVerticalM,
  },
  progressWrapper: {
    width: tokens.fontSizeHero900,
    height: tokens.fontSizeHero900,
    ...flexCenter,
    justifyContent: 'center',
  },
  statusIcon: {
    '& svg': {
      width: tokens.fontSizeHero900,
      height: tokens.fontSizeHero900,
    },
  },
  statusIconOnTrack: {
    '& svg': { color: tokens.colorPaletteLightGreenBackground3 },

  },
  statusIconOffTrack: {
    '& svg': { color: tokens.colorPaletteRedForeground1 },
  },
  statusIconAtRisk: {
    '& svg': { color: tokens.colorPaletteMarigoldBackground3 },
  },
  label: {
    fontSize: tokens.fontSizeBase300,
    textAlign: 'center',
    color: tokens.colorNeutralForeground1,
  },
  statusRow: {
    display: 'flex',
    justifyContent: 'center',
  },
  statusText: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightRegular,
  },
  statusOnTrack: {
    ...statusHighlight,
    color: tokens.colorPaletteLightGreenForeground2,
  },
  statusOffTrack: {
    ...statusHighlight,
    color: tokens.colorPaletteRedForeground2,
  },
  statusAtRisk: {
    ...statusHighlight,
    color: tokens.colorPaletteMarigoldForeground2,
  },
});
